import React, { useState, useEffect } from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const MaturatoAnalisiKPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const shaped = { items: [...(filterModel.items || []), { field: "status", operator: "equals", value: "accepted" }] };
        setLocalFilterModel(shaped);
        setLocalDrawable(true);
    }, [filterModel]);

    const { getComparableTimeframe } = useDates();

    if (!localDrawable || !localFilterModel) {
        return null;
    }

    const commissionCompare = {
        ...getComparableTimeframe(localFilterModel, 'registered_at'),
        timeline: {
            collection: 'views_opportunities_proposal',
            field: 'registered_at',
            granularity: 'month',
            sumfield: 'totalCommissionValue'
        }
    };

    return (
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Maturato"
                dataProviderName={'statisticsviews/item/sumfinancial/opportunities/proposal/totalCommissionValue'}
                filters={localFilterModel}
                format='currency'
                compactformat={false}
                decimaldigits={'standard'}
                compareFilters={commissionCompare}
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Accettate"
                dataProviderName={'statisticsviews/item/count/opportunities/proposal'}
                filters={localFilterModel}
                compareFilters={
                    {
                        ...getComparableTimeframe(localFilterModel, 'registered_at'),
                        timeline: {
                            collection: 'views_opportunities_proposal',
                            field: 'registered_at',
                            granularity: 'month'
                        }
                    }
                }
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="CPA | Costo accettata"
                dataProviderName={'statisticsviews/item/costperunit/opportunities/proposal'}
                filters={localFilterModel}
                format='currency'
                compactformat={false}
                decimaldigits={'standard'}
                compareFilters={getComparableTimeframe(localFilterModel, 'registered_at')}
                comparePositiveCondition={'inverse'}
            />
        </Box>
    );
};

export default MaturatoAnalisiKPISet;

